export default __webpack_public_path__ + "static/media/3-2.58f316f0.png";